import * as React from "react"
import PrimaryButton from "../PrimaryButton"
import { useSelector } from "react-redux"
import * as AppTypes from "AppTypes"

interface IEntryAddition {
    actionHandler: () => void
    existing: number
}
const EntryAddition: React.FC<IEntryAddition> = props => {
    const { actionHandler, existing } = props
    const { langPack } = useSelector((store: AppTypes.ReducerState) => ({
        langPack: store.config.langPack
    }))

    // const seqText = ["first", "second", "third"]

    return (
        <div className="dashboard__entries__summary add-entry container">
            <div className="add-entry__content">
                {existing < 1 && <React.Fragment>
                <h3>{langPack["uploadArt"]}</h3>
                    <span>{langPack["submitArt"]}</span>
                </React.Fragment>}
            </div>
            <div className="add-entry__action">
                <div className="add-entry__action--wrapper">
                    <PrimaryButton
                        text="+"
                        className="button-plus"
                        onClick={actionHandler}
                    >
                        <span>+</span>
                    </PrimaryButton>
                    <div className="button-text">{(existing < 1 ) ? langPack["addArtwork"] : langPack["addAnotherArtwork"]}</div>
                </div>
            </div>

        </div>
    )
}

export default EntryAddition
